// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2M-IY","containerItemsCenter":"Skeleton_containerItemsCenter__2THZZ"};